import { useConsent } from "~/contexts/consent";
import { cn } from "~/lib/cn";

/**
 * The "Cookie settings" link of the site footers. It sits in a row of text
 * links but opens a dialog, so it is a plain button styled like its
 * neighbours: the Button component's fixed height would break the row.
 */
export function CookieSettingsButton({
  className,
}: {
  readonly className?: string;
}): React.JSX.Element {
  const { openSettings } = useConsent();
  return (
    <button
      type="button"
      onClick={openSettings}
      className={cn("cursor-pointer", className)}
    >
      Cookie settings
    </button>
  );
}
